import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import './styles.css';
import service from '../services-service';
import { fromEpoch } from '../../../utils/dates';
import Pagination from '../../../base/Pagination';
import { detailsToSidebar } from '../services-utils';
import AppList from '../../../components/app-list/AppList';
import AppSpinnerComponent from '../../../components/app-spinner/AppSpinner';
import AppSidebarComponent from '../../../components/app-sidebar/AppSidebar';
import { update as updateBreadCrumb } from '../../../components/app-breadcrumb/app-breadcrumb-actions';
import AppParagraph from '../../../components/app-paragraph/AppParagraph';

class ServiceDetailsContainer extends React.Component {
  serviceId;
  pagination = new Pagination();

  constructor(props) {
    super(props);
    this.serviceId = this.props.match.params.serviceId;
    this.state = {
      loading: true,
      service: null,
      events: []
    };
  }

  componentDidMount() {
    const { startRange, endRange } = this.pagination;
    const search = new URLSearchParams();
    search.append('school_id', this.props.session.school.id);

    service
      .getServiceById(this.serviceId, search)
      .then(response => {
        this.setState({ service: response });

        const search = new URLSearchParams();
        search.append('store_id', response.store_id);
        search.append('school_id', this.props.session.school.id);

        return service.getEventsByServiceId(startRange, endRange, search);
      })
      .then(events => {
        this.setState(
          {
            loading: false,
            events: events.map(event => {
              return {
                id: event.id,
                heading: event.title,
                linkTo: `/events/${event.id}`,
                description: event.description,
                subheading: fromEpoch(event.start),
                image: event.poster_thumb_url
              };
            })
          },
          () => {
            this.props.dispatch(
              updateBreadCrumb([
                {
                  url: `services/${this.state.service.id}`,
                  label: this.state.service.name
                }
              ])
            );
          }
        );
      })
      .catch(() => {
        this.props.history.replace('/services');
      });
  }
  render() {
    return this.state.loading ? (
      <AppSpinnerComponent centered />
    ) : (
      <div className="page-padding-top">
        <p className="h1 strong">{this.state.service.name}</p>
        <Row>
          <Col xs={12} lg={8} className="description">
            <article>
              <AppParagraph text={this.state.service.description} />
              <div className="service_details_list">
                <AppList items={this.state.events} />
              </div>
            </article>
          </Col>
          <Col xs={12} lg={{ size: 3, offset: 1 }} className="meta">
            <AppSidebarComponent {...detailsToSidebar(this.state.service)} />
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(ServiceDetailsContainer);
